import type {SupportedLocales} from '@/lib/locale/locale'
import {getProductDetailsQueryOptions} from '@/lib/product/hooks/useProductDetails'
import {type Product, RETAILERS_SHOULD_PRELOAD} from '@/models/productModel'

export const NOT_GOING_TO_PRELOAD = 'NOT_GOING_TO_PRELOAD' as const

export default async function preloadProduct(
  product: Pick<Product, 'retailer' | 'id'>,
  locale: SupportedLocales,
  queryClient: QueryClient,
  forcePreload = false,
) {
  if (!forcePreload && !RETAILERS_SHOULD_PRELOAD.includes(product.retailer))
    return Promise.resolve(NOT_GOING_TO_PRELOAD)

  return queryClient.ensureQueryData(
    getProductDetailsQueryOptions({
      retailer: product.retailer,
      id: product.id,
      locale,
      preload: true,
    }),
  )
}
